import React, { useContext, useRef } from 'react';
import Axios from 'axios';
import { AppConfigContext, axios_timeout } from '../../Config/App';
import { toast } from 'react-toastify';
import InputText from '../../Components/forms/inputText';
import Logo from '../../Components/logo';
import { LanguageContext } from '../../Data/Context/languageContext';

const ActivateAccount = ({ classes }) => {
  const { api_url } = useContext(AppConfigContext);
  const successMsg = 'successMsg';
  const errorMsg = 'errorMsg';
  const form = useRef();
  const { t } = useContext(LanguageContext);

  const onSubmit = (e) => {
    e.preventDefault();

    const activation_key = e.target.activation_key.value;

    if (activation_key)
      Axios.post(api_url(`activate-account/${activation_key}`), { timeout: axios_timeout }).then(
        (response) => {
          if (response.status === 200) {
            success();
          } else {
            error();
          }
        }
      );
  };

  const success = () => {
    toast.success(t('account_activated'), {
      toastId: successMsg,
      autoClose: false,
    });
  };

  const error = () => {
    toast.error(t('toast_unexpected_error'), {
      toastId: errorMsg,
      autoClose: false,
    });
  };

  return (
    <div className={classes}>
      <div
        className={
          'col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto rounded-3 text-center custom-border'
        }>
        <Logo classes={'m-3'} />

        <h3>{t('activate_account')} </h3>
        <form
          onSubmit={onSubmit}
          ref={form}>
          <div className='form-group'>
            <InputText
              isForm={true}
              placeholder='Activation key'
              name='activation_key'>
              {t('activation_key')}
            </InputText>
          </div>

          <div className='d-grid col text-center mb-3 '>
            <button
              type='submit'
              className='btn btn-primary'>
              {t('submit')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default ActivateAccount;
